import { baseAccessFactory } from './base/baseAccess';

export default function accessFactory(initialState) {
  return baseAccessFactory(initialState);
}
